import { ReducerCreators } from '@reduxjs/toolkit';
import { AudiencesState } from '../types';
import { initialState } from '../initial';

export const resetListAttendees = (create: ReducerCreators<AudiencesState>) =>
  create.reducer((state) => {
    state.listAttendees = initialState.listAttendees;
  });
